import { toast } from "react-toastify";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../../../theme/Component/usePaginator";
import { useEffect } from "react";
import useModal, { MODAL_md, MODAL_SM } from "../../../../../../theme/Component/hooks/useModal";
import { _FixedAssetGroups, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { BasicTable, MASK_DATE } from "../../../../../../theme/Component/BasicTable";


interface Form {
    State: number;
    Location: number;
}

export const FixedAssetGroups = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_FixedAssetGroups);
    const paginator = usePaginator();

    const modalC = useModal(``, MODAL_SM);
    const modal = useModal(``, MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginator.page])

    const getLista = () => {
        const props = {
            State: 1
        }

        instance.getFixedAssetGroupsCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Grupos de activos");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Crear grupo de Activo");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 3 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        //console.log(abilityType.bean);
        instance.updateFixedAssetGroups(obj).then(
            (resp: any) => {
                getLista();
                modalC.close();
                modal.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDFixedAssetGroups', visible: true },
        { title: 'Nombre', property: 'GroupName', visible: true },
        { title: 'Descripción', property: 'GroupDescription', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true, mask: MASK_DATE },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar grupo ${bean.GroupName}`) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(`Eliminar Grupo ${bean.GroupName}`); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Grupos de Activos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                    />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre del Grupo</label>
                                <input type="text" className="form-control" value={bean.GroupName} onChange={((e) => { setBean({ ...bean, GroupName: e.target.value }) })} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea rows={5} value={bean.GroupDescription} onChange={(e) => { setBean({ ...bean, GroupDescription: e.target.value }) }} className="form-control" />
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.GroupName}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}